export enum CommunicationsResponseGetSessionIdError {
  unableToGetSessionId = 'unableToGetSessionId',
}
